// breadcrumbConfig.js
const breadcrumbNameMap = {
    "/clm_home": "Signed Contracts",
    "/wip-contracts":"WIP Contracts",
    "/trash": "Archive",
    "/recents": "Recent",
    "/categories": "Details",
    "/templates": "Templates",
    "/sales-contracts": "Sales Contracts",
    "/purchase-orders": "Purchase Orders",
    "/roles":"Roles",
    "/contract-status":"Contract Status",
    "/contract-types":"Contract Types",
    "/practices":"Practices",
    "/departments":"Departments",
    "/currencies":"Currency",
    "/admin-dashboard":"Admin Dashboard",
    "/clients":"Clients"
  };
  
  export default breadcrumbNameMap;
  